
import { StyleValue } from '@/shared/app/model/StyleValue';
import Base from '@/shared/app/ui/Base.vue';
import Component from 'vue-class-component';
import imgA from '../../carbonscore/a.png';
import imgB from '../../carbonscore/b.png';
import imgC from '../../carbonscore/c.png';
import imgD from '../../carbonscore/d.png';
import imgE from '../../carbonscore/e.png';

const CARBON_IMAGES: Record<string, string> = {
  a: imgA,
  b: imgB,
  c: imgC,
  d: imgD,
  e: imgE,
};

@Component
export default class CarbonscoreDisplay extends Base {
  get carbonscoreKey() {
    return this.carbonscore || '';
  }

  get carbonscore() {
    return this.config?.carbonscore?.toString() || '';
  }

  get carbonscoreData() {
    const key = this.carbonscoreKey;
    if (!key) return null;
    const data = this.dataset('carbonscore')[key];
    if (!data) return null;
    return {
      imageUrl: key,
    };
  }

  get containerStyle(): StyleValue {
    return {
      backgroundColor: this.carbonscoreColor,
      borderRadius: `${this.sizeFactor * 1}rem`,
      padding: `${this.sizeFactor * 1}rem`,
      marginLeft: `${this.sizeFactor * 2.2}rem`,
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      flexShrink: 0,
    };
  }

  get imageStyle(): StyleValue {
    if (!this.carbonscoreKey) return {};
    const size = `${this.sizeFactor * 8}rem`;
    const imagePath = CARBON_IMAGES[this.carbonscoreKey];
    return {
      backgroundImage: `url(${imagePath})`,
      backgroundSize: 'contain',
      backgroundRepeat: 'no-repeat',
      backgroundPosition: 'center',
      height: size,
      width: size,
    };
  }

  get carbonscoreColor() {
    const colors: { [key: string]: string } = {
      a: '#4CAF50', 
      b: '#8BC34A', 
      c: '#FFEB3B', 
      d: '#FF9800', 
      e: '#F44336',
    };
    return colors[this.carbonscoreKey] || '#FFFFFF';
  }
}
